// extracted by mini-css-extract-plugin
export default {"wrapper":"ResetPassword_wrapper__CMazj","info":"ResetPassword_info__sNESm","form":"ResetPassword_form__qjqjq"};